import React from "react";
import { animated } from "react-spring";
import PropTypes from "prop-types";
function PhotoViewer({ photo, animatedStyle, imgHeight = 300 }) {
  const photoRef = React.useRef(photo);

  return (
    <animated.div style={animatedStyle} className="offer-photos__photo-viewer">
      <div className="offer-photos__photo-viewer-imgContainer">
        <img
          className="offer-photos__photo-viewer-img"
          style={{
            height: imgHeight,
          }}
          alt=""
          src={photo || photoRef.current}
        />
      </div>
    </animated.div>
  );
}

PhotoViewer.propTypes = {
  photo: PropTypes.string,
  animatedStyle: PropTypes.object.isRequired, // React spring style object
  imgHeight: PropTypes.number,
};

export default PhotoViewer;
